export const SEARCH_PLACEHOLDERS = {
  SCHEMA: '컬럼 이름, 설명, 태그, 용어로 검색',
  SCHEMAS: '스키마 이름, 설명, 태그, 용어로 검색',
  TABLES: '테이블 이름, 설명, 태그, 용어로 검색',
  DATABASES: '스키마 이름, 설명, 태그, 용어로 검색',
  ML_MODELS: 'ML 검색...',
  VERSIONS: '버전, 생성자, 태그, 별칭, 설명으로 검색',
} as const;
